import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import {
	DEFAULT_ROLL_COUNT,
	type StraightenerParamGroup,
	type StraightenerParameter,
	parametersByGroup,
} from "../parameterCatalog";
import { getStraightenerParameterCatalog } from "../repositories/StraightenerParametersRepository";

export const STR_PARAM_CATALOG_KEY = ["straightenerParamCatalog"] as const;

const EMPTY: StraightenerParameter[] = [];

// DB-backed parameter catalog shared by the Recipes editor and the Trend
// Display. Cached: the catalog only changes on deployments/config edits.
export const useStraightenerParameters = () => {
	const { data, isLoading } = useQuery({
		queryKey: STR_PARAM_CATALOG_KEY,
		queryFn: getStraightenerParameterCatalog,
		staleTime: 5 * 60 * 1000,
	});

	const parameters = data?.parameters ?? EMPTY;

	return useMemo(
		() => ({
			parameters,
			isLoading,
			rollCount: data?.rollCount || DEFAULT_ROLL_COUNT,
			byCode: new Map(parameters.map((p) => [p.code, p])),
			byGroup: parametersByGroup(parameters) as Record<
				StraightenerParamGroup,
				StraightenerParameter[]
			>,
		}),
		[parameters, isLoading, data?.rollCount],
	);
};
